import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ProductPriceComponent } from '../../blocks/product-price/product-price.component';
import { MenuListRepository } from '../../shared/repositories/menu-list.repository';
import { MenuItemSizeDto } from '../../api/v1/models/menu-item-size-dto';
import { CounterComponent } from '../../shared/components/counter/counter.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { BasketRepository } from '../../shared/repositories/basket.repository';
import { Observable, tap } from 'rxjs';
import { UIMenuItemDto } from '../../shared/interfaces/ui-menu-item-dto.interface';
import { BasketItem } from '../../shared/interfaces/basket-item.interface';
import { Router } from '@angular/router';
import { CropTextPipe } from '../../shared/pipes/crop-text/crop-text.pipe';
import { ConfigRepository } from '../../shared/repositories/config.repository';
import { SessionRepository } from '../../shared/repositories/session.repository';
import { ModifierItem } from '../modifier-list/modifier-item.interface';

@Component({
  selector: 'app-related-card',
  standalone: true,
  templateUrl: './related-card.component.html',
  styleUrls: ['./related-card.component.scss'],
  imports: [
    CommonModule,
    NgOptimizedImage,
    ProductPriceComponent,
    CounterComponent,
    ReactiveFormsModule,
    CropTextPipe,
  ]
})
export class RelatedCardComponent implements OnChanges {
  constructor (
    private router: Router,
    private menuListRepository: MenuListRepository,
    private basketRepository: BasketRepository,
    private configRepository: ConfigRepository,
    private sessionRepository: SessionRepository,
  ) {}

  @Input() product: UIMenuItemDto;

  counterControl: FormControl<number> = new FormControl<number>(1, {nonNullable: true});

  currentSize: MenuItemSizeDto | undefined;
  defaultPrice$: Observable<number | null>;

  basketItem$: Observable<BasketItem | null>;
  isBasketMode$: Observable<boolean> = this.configRepository.isBasketMode$;

  ngOnChanges(): void {
    this.currentSize = this.menuListRepository.getDefaultSize(this.product);
    this.defaultPrice$ = this.menuListRepository.getDefaultPriceObservable(this.currentSize);

    this.basketItem$ = this.basketRepository.getBasketItem$(this.product.uniqKey).pipe(
      tap((item: BasketItem | null) => {
        if (!item) {return}
        this.counterControl.patchValue(item.count);
      })
    );
  }

  onChangeCount(itemKey: string, count: number): void {
    if(count === 0) {
      this.basketRepository.removeItem(itemKey);
      return;
    }
    this.basketRepository.updateCount(itemKey, count);
  }

  onAddItem (slug: string | null): void {
    if (!slug || !this.currentSize) {return}

    if (this.currentSize.itemModifierGroups.length) {
      this.onOpenCard(slug);
      return;
    }

    const modifiers: ModifierItem[] = [];
    const count: number = 1;

    this.basketRepository.addItem({
      item: this.product,
      size: this.currentSize,
      count: count,
      modifiers: modifiers,
      appliedDiscount: 0,
      itemKey: '',
      totalPrice: this.sessionRepository.getItemTotal(this.currentSize.prices, modifiers, count),
    })
  }

  onOpenCard(slug: string | null): void {
    if (!slug) { return }
    this.menuListRepository.setActiveCategory(this.product.categoryId);
    void this.router.navigate([`/category/${this.product.categorySlug}/${slug}`]);
  }

}
